'use strict'

// Navigation sans rechargement (SPA-like)
function initPage() {

    // ===== ALERT ERREUR =====
    const errorBtn = document.querySelector(".error-btn");
    const errorBlock = document.querySelector(".alert");

    if (errorBtn && errorBlock) {
        errorBtn.addEventListener("click", () => {
            errorBlock.classList.toggle("alert--hide");
        });
    }

    // Réinitialiser les tabs si on est sur la page équipe
    const tabJoueurs = document.getElementById('tab-joueurs');
    const tabMatchs = document.getElementById('tab-matchs');
    const btnJoueurs = document.getElementById('btn-joueurs');
    const btnMatchs = document.getElementById('btn-matchs');

    if (tabJoueurs && tabMatchs) {
        window.showTab = function (tab) {
            tabJoueurs.style.display = tab === 'joueurs' ? 'block' : 'none';
            tabMatchs.style.display = tab === 'matchs' ? 'block' : 'none';
            btnJoueurs.classList.toggle('active', tab === 'joueurs');
            btnMatchs.classList.toggle('active', tab === 'matchs');
        }
    }

    //Dots Register

    const steps = document.querySelectorAll(".step");
    const dots = document.querySelectorAll(".step-dot");
    const nextBtn = document.querySelector(".next-btn");
    const form = document.querySelector(".formInscription");

    if (steps.length && nextBtn) {
        let currentStep = 0;

        function showStep(index) {
            steps.forEach(step => step.classList.remove("active"));
            if (steps[index]) steps[index].classList.add("active");
        }

        function validateStep(stepIndex) {
            const inputs = steps[stepIndex].querySelectorAll("input");
            let isValid = true;
            inputs.forEach(input => {
                if (!input.checkValidity()) {
                    isValid = false;
                    input.reportValidity();
                }
            });
            return isValid;
        }

        function updateUI() {
            dots.forEach((dot, i) => {
                dot.classList.remove("active", "done", "disabled");
                if (i < currentStep) dot.classList.add("done");
                else if (i === currentStep) dot.classList.add("active");
                else dot.classList.add("disabled");
            });
            updateButton();
        }

        function updateButton() {
            if (currentStep === steps.length - 1) {
                nextBtn.textContent = "Valider";
                nextBtn.type = "submit";
            } else {
                nextBtn.textContent = "Suivant";
                nextBtn.type = "button";
            }
        }

        function nextStep() {
            if (!validateStep(currentStep)) return;
            if (currentStep < steps.length - 1) {
                currentStep++;
                showStep(currentStep);
                updateUI();
            }
        }

        nextBtn.addEventListener("click", () => {
            if (nextBtn.type === "button") nextStep();
        });

        dots.forEach(dot => {
            dot.addEventListener("click", () => {
                const stepIndex = parseInt(dot.dataset.step);
                if (stepIndex <= currentStep) {
                    currentStep = stepIndex;
                    showStep(currentStep);
                    updateUI();
                }
            });
        });

        form.addEventListener("submit", (e) => {
            if (!validateStep(currentStep)) e.preventDefault();
        });

        showStep(currentStep);
        updateUI();
    }

    // ===== SELECTION JOUEURS =====
    const checkboxes = document.querySelectorAll('.joueur-select-card input[type="checkbox"]');
    const nbSelectionnes = document.getElementById('nb-selectionnes');

    if (checkboxes.length && nbSelectionnes) {
        function updateCount() {
            const nb = document.querySelectorAll('.joueur-select-card input[type="checkbox"]:checked').length;
            nbSelectionnes.textContent = nb;
        }

        checkboxes.forEach(cb => {
            cb.addEventListener('change', () => {
                const card = cb.closest('.joueur-select-card');
                card.classList.toggle('joueur-select-card--selected', cb.checked);
                updateCount();
            });
        });

        updateCount();
    }


    // ===== CALENDRIER =====


    const grid = document.getElementById('calendrier-grid');
    if (grid) {
        const matchs = window.matchsData || [];
        const moisNoms = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
            'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        const moisCourts = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun',
            'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];

        let today = new Date();
        let currentYear = today.getFullYear();
        let currentMonth = today.getMonth();

        function indexerMatchs() {
            const index = {};
            matchs.forEach(m => {
                const date = m.date_match.substring(0, 10);
                if (!index[date]) index[date] = [];
                index[date].push(m);
            });
            return index;
        }

        function renderCalendrier(year, month) {
            const cal = document.getElementById('calendrier-grid');
            if (!cal) return;

            const index = indexerMatchs();
            const firstDay = new Date(year, month, 1);
            const lastDay = new Date(year, month + 1, 0);

            document.getElementById('current-month').textContent = moisNoms[month] + ' ' + year;
            document.getElementById('prev-label').textContent = moisCourts[(month - 1 + 12) % 12];
            document.getElementById('next-label').textContent = moisCourts[(month + 1) % 12];

            let startDay = firstDay.getDay() - 1;
            if (startDay < 0) startDay = 6;

            cal.innerHTML = '';

            for (let i = 0; i < startDay; i++) {
                cal.innerHTML += '<div class="cal-day cal-day--empty"></div>';
            }

            for (let d = 1; d <= lastDay.getDate(); d++) {
                const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
                const matchsJour = index[dateStr] || [];
                const isToday = (d === today.getDate() && month === today.getMonth() && year === today.getFullYear());

                let dotsHtml = matchsJour.map(m =>
                    `<span class="cal-dot" style="background-color:${m.couleur}"></span>`
                ).join('');

                cal.innerHTML += `
            <div class="cal-day ${isToday ? 'cal-day--today' : ''} ${matchsJour.length ? 'cal-day--has-match' : ''}"
                 data-date="${dateStr}">
                <span class="cal-day__num">${d}</span>
                <div class="cal-day__dots">${dotsHtml}</div>
            </div>`;
            }

            cal.querySelectorAll('.cal-day:not(.cal-day--empty)').forEach(el => {
                el.addEventListener('click', () => {
                    const date = el.dataset.date;
                    const matchsJour = index[date] || [];

                    if (el.classList.contains('cal-day--selected')) {
                        el.classList.remove('cal-day--selected');
                        document.getElementById('calendrier-detail').innerHTML = `
                    <p class="calendrier__detail__empty">
                        Sélectionnez une date pour voir les interclubs prévus ce jour
                    </p>`;
                        return;
                    }

                    cal.querySelectorAll('.cal-day').forEach(d => d.classList.remove('cal-day--selected'));
                    el.classList.add('cal-day--selected');

                    if (matchsJour.length > 0) {
                        afficherDetail(matchsJour);
                    } else {
                        document.getElementById('calendrier-detail').innerHTML = `
                    <p class="calendrier__detail__empty">
                        Aucun match n'est prévu ce jour !
                    </p>`;
                    }
                });
            });
        }

        function afficherDetail(matchsJour) {
            const detail = document.getElementById('calendrier-detail');
            let html = '';

            matchsJour.forEach(m => {
                const heure = m.date_match.substring(11, 16);
                html += `
                <h3 class="title--calendar">MES INTERCLUBS PLANIFIÉS</h3>
                <div class="detail-match-card">
                    <div class="detail-match-card__equipe">
                        ${m.equipe_nom} <div class="cat--calendar"> ${m.categorie} ${m.division} </div>
                    </div>
                    <div class="detail-match-card__adversaire"> <svg width="19" height="22" viewBox="0 0 19 22" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.5796 16.4785L1.01309 3.88572L1.27737 0.864937L4.29815 1.12922L14.8647 13.722"
                                stroke="#6C5CE7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.9125 17.8773L16.4826 12.3643" stroke="#6C5CE7" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.1891 15.1279L16.8644 19.508" stroke="#6C5CE7" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.7608 20.434L17.9509 18.5963" stroke="#6C5CE7" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.4245 4.84691L14.6404 1.01433L17.6611 0.750046L17.9254 3.77083L14.7095 7.60341"
                                stroke="#6C5CE7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M2.77225 13.4645L7.15233 17.1398" stroke="#6C5CE7" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.11233 16.3384L2.35584 19.6234" stroke="#6C5CE7" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1.29938 18.7362L3.48942 20.5739" stroke="#6C5CE7" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg> Contre ${m.adversaire}</div>
                    <div class="detail-match-card__infos">
                     <svg width="18" height="22" viewBox="0 0 18 22" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.75 8.75C16.75 13.743 11.211 18.943 9.351 20.549C9.17772 20.6793 8.9668 20.7498 8.75 20.7498C8.5332 20.7498 8.32228 20.6793 8.149 20.549C6.289 18.943 0.75 13.743 0.75 8.75C0.75 6.62827 1.59285 4.59344 3.09315 3.09315C4.59344 1.59285 6.62827 0.75 8.75 0.75C10.8717 0.75 12.9066 1.59285 14.4069 3.09315C15.9071 4.59344 16.75 6.62827 16.75 8.75Z"
                                stroke="#6C5CE7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.75 11.75C10.4069 11.75 11.75 10.4069 11.75 8.75C11.75 7.09315 10.4069 5.75 8.75 5.75C7.09315 5.75 5.75 7.09315 5.75 8.75C5.75 10.4069 7.09315 11.75 8.75 11.75Z"
                                stroke="#6C5CE7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> ${m.lieu}
                    </div>
                </div>`;
            });

            detail.innerHTML = html;

            // Réattacher les listeners présence sur les nouveaux boutons
            detail.querySelectorAll('.btn-presence').forEach(btn => {
                btn.addEventListener('click', async (e) => {
                    e.preventDefault();
                    const form = btn.closest('form');
                    const matchId = form.querySelector('[name="match_id"]').value;
                    const disponible = btn.value;

                    await fetch('/includes/config_db/presence.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: `match_id=${matchId}&disponible=${disponible}`
                    });

                    form.querySelectorAll('.btn-presence').forEach(b => b.classList.remove('active'));
                    btn.classList.add('active');
                });
            });
        }

        document.getElementById('prev-month').addEventListener('click', () => {
            currentMonth--;
            if (currentMonth < 0) { currentMonth = 11; currentYear--; }
            renderCalendrier(currentYear, currentMonth);
        });

        document.getElementById('next-month').addEventListener('click', () => {
            currentMonth++;
            if (currentMonth > 11) { currentMonth = 0; currentYear++; }
            renderCalendrier(currentYear, currentMonth);
        });

        renderCalendrier(currentYear, currentMonth);
    }


    // ===== COVOITURAGE =====
    const covMap = document.getElementById('covoiturage-map');
    if (covMap && window.covoiturageData) {
        const { joueurs, lieu, couleur, orsKey } = window.covoiturageData;

        if (covMap._leaflet_id) {
            covMap._leaflet_id = null;
            covMap.innerHTML = '';
        }

        const leafletMap = L.map(covMap).setView([50.4, 4.4], 10);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap'
        }).addTo(leafletMap);

        async function geocode(adresse) {
            const url = `https://api.openrouteservice.org/geocode/search?api_key=${orsKey}&text=${encodeURIComponent(adresse)}&boundary.country=BE&size=1`;
            const res = await fetch(url);
            const data = await res.json();
            if (data.features && data.features.length > 0) {
                const [lng, lat] = data.features[0].geometry.coordinates;
                return { lat, lng, label: data.features[0].properties.label };
            }
            return null;
        }

        async function getItineraire(coords) {
            const body = { coordinates: coords.map(c => [c.lng, c.lat]) };
            const res = await fetch('https://api.openrouteservice.org/v2/directions/driving-car/json', {
                method: 'POST',
                headers: {
                    'Authorization': orsKey,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            return await res.json();
        }

        function decodePolyline(encoded) {
            const points = [];
            let index = 0, lat = 0, lng = 0;
            while (index < encoded.length) {
                let shift = 0, result = 0, b;
                do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
                lat += (result & 1) ? ~(result >> 1) : result >> 1;
                shift = result = 0;
                do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
                lng += (result & 1) ? ~(result >> 1) : result >> 1;
                points.push([lat / 1e5, lng / 1e5]);
            }
            return points;
        }

        function distGeo(p1, p2) {
            return Math.sqrt(Math.pow(p1.lat - p2.lat, 2) + Math.pow(p1.lng - p2.lng, 2));
        }

        async function initCovoiturage() {
            const resultDiv = document.getElementById('itineraire-result');


            const points = [];
            for (const joueur of joueurs) {
                const coord = await geocode(joueur.adresse);
                if (coord) {
                    points.push({ ...coord, nom: `${joueur.prenom} ${joueur.nom}` });
                }
            }

            const destination = await geocode(lieu);
            if (!destination) {
                resultDiv.innerHTML = '<p class="empty-msg">Impossible de localiser le lieu du match.</p>';
                return;
            }

            if (points.length === 0) {
                resultDiv.innerHTML = '<p class="empty-msg">Impossible de géolocaliser les adresses des joueurs.</p>';
                return;
            }


            const iconJoueur = L.divIcon({
                className: '',
                html: `<div style="background:${couleur};width:12px;height:12px;border-radius:50%;border:2px solid white;box-shadow:0 0 4px rgba(0,0,0,0.3)"></div>`,
                iconSize: [12, 12]
            });
            points.forEach(p => {
                L.marker([p.lat, p.lng], { icon: iconJoueur })
                    .addTo(leafletMap)
                    .bindPopup(`<strong>${p.nom}</strong><br>${p.label}`);
            });


            const joueurLePlusLoin = points.reduce((max, p) =>
                distGeo(p, destination) > distGeo(max, destination) ? p : max
                , points[0]);

            // 4. Route complète du joueur le plus loin vers la destination
            const routeComplete = await getItineraire([joueurLePlusLoin, destination]);

            if (!routeComplete.routes || !routeComplete.routes[0]) {
                resultDiv.innerHTML = '<p class="empty-msg">Erreur lors du calcul.</p>';
                return;
            }


            const routePoints = decodePolyline(routeComplete.routes[0].geometry);

            let meilleurIndex = 0;
            let meilleurScore = Infinity;

            for (let pct = 0.4; pct <= 0.8; pct += 0.05) {
                const idx = Math.floor(routePoints.length * pct);
                const candidat = { lat: routePoints[idx][0], lng: routePoints[idx][1] };
                const score = points.reduce((sum, p) => sum + distGeo(p, candidat), 0);
                if (score < meilleurScore) {
                    meilleurScore = score;
                    meilleurIndex = idx;
                }
            }

            const pointRdv = {
                lat: routePoints[meilleurIndex][0],
                lng: routePoints[meilleurIndex][1]
            };


            const rdvNom = await fetch(
                `https://api.openrouteservice.org/geocode/reverse?api_key=${orsKey}&point.lon=${pointRdv.lng}&point.lat=${pointRdv.lat}&size=1`
            ).then(r => r.json()).then(d => d.features?.[0]?.properties?.label ?? 'Point de rendez-vous');

            // 7. Marqueur RDV
            const iconRdv = L.divIcon({
                className: '',
                html: `<div style="background:#00B894;width:16px;height:16px;border-radius:50%;border:2px solid white;box-shadow:0 0 4px rgba(0,0,0,0.3)"></div>`,
                iconSize: [16, 16]
            });
            L.marker([pointRdv.lat, pointRdv.lng], { icon: iconRdv })
                .addTo(leafletMap)
                .bindPopup(`<strong>📍 Point de rendez-vous</strong><br>${rdvNom}`)
                .openPopup();


            const iconDest = L.divIcon({
                className: '',
                html: `<div style="background:#D63031;width:16px;height:16px;border-radius:50%;border:2px solid white;box-shadow:0 0 4px rgba(0,0,0,0.3)"></div>`,
                iconSize: [16, 16]
            });
            L.marker([destination.lat, destination.lng], { icon: iconDest })
                .addTo(leafletMap)
                .bindPopup(`<strong>🏸 Lieu du match</strong><br>${destination.label}`);

            const allPoints = [...points, pointRdv, destination];
            const bounds = L.latLngBounds(allPoints.map(p => [p.lat, p.lng]));
            leafletMap.fitBounds(bounds, { padding: [30, 30] });
        }

        initCovoiturage().catch(err => console.error('Erreur initCovoiturage:', err));
    }

}

document.addEventListener('click', async (e) => {
    const link = e.target.closest('a');
    if (!link || link.href.includes('#') || link.target === '_blank') return;
    if (!link.href.startsWith(window.location.origin)) return;

    e.preventDefault();
    const res = await fetch(link.href);
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    document.querySelector('body').innerHTML = doc.querySelector('body').innerHTML;
    window.history.pushState({}, '', link.href);

    initPage();
});


initPage();